import { TFunction } from 'i18next'

import { SelectOption } from '@/components/ui/select'

export const VISITORS_ANALYTICS_STORAGE_KEY = 'visitors-analytics-open'

export const getPeriodOptions = (t: TFunction<['visitors']>): SelectOption<string>[] => [
  { label: t('visitors:periods.last7Days'), value: '7' },
  { label: t('visitors:periods.last30Days'), value: '30' },
  { label: t('visitors:periods.last60Days'), value: '60' },
  { label: t('visitors:periods.last90Days'), value: '90' },
]

export const DEFAULT_PERIOD = '30'
